import {
  Component,
  OnInit,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
    selector: 'wm-workflow-application-list-view',
    templateUrl: './workflow-application-list-view.component.html',
    styleUrls: ['./workflow-application-list-view.component.css'],
    standalone: false
})
export class WorkflowApplicationListViewComponent implements OnInit {
  @Output() filtersChanged = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() { }

  filtersChange() {
    this.filtersChanged.emit(true);
  }
}
